import type {} from "@lit/react";
import { VerticalLayout as VerticalLayoutElement, } from "@vaadin/vertical-layout/vaadin-vertical-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { VerticalLayoutElement, };
export type VerticalLayoutEventMap = Readonly<{}>;
const events = {} as VerticalLayoutEventMap;
export type VerticalLayoutProps = WebComponentProps<VerticalLayoutElement, VerticalLayoutEventMap>;
export const VerticalLayout = createComponent({
    elementClass: VerticalLayoutElement, events, react: React, tagName: "vaadin-vertical-layout"
});
